import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import SocialProof from '@/components/SocialProof';
import HomePage from '@/pages/HomePage';
import AboutPage from '@/pages/AboutPage';
import VerifyCertificatePage from '@/pages/VerifyCertificatePage';
import TestimonialsPage from '@/pages/TestimonialsPage';
import CompaniesPage from '@/pages/CompaniesPage';
import EthicalHackingJaipur from '@/pages/seo/EthicalHackingJaipur';
import CyberSecurityTrainingJaipur from '@/pages/seo/CyberSecurityTrainingJaipur';
import SOCAnalystCourseJaipur from '@/pages/seo/SOCAnalystCourseJaipur';
import VAPTTrainingJaipur from '@/pages/seo/VAPTTrainingJaipur';
import BugBountyCourseJaipur from '@/pages/seo/BugBountyCourseJaipur';
import DigitalForensicsJaipur from '@/pages/seo/DigitalForensicsJaipur';
import RefundPolicyPage from '@/pages/RefundPolicyPage';
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage';
import TermsConditionsPage from '@/pages/TermsConditionsPage';

function App() {
  return (
    <div className="App bg-black min-h-screen">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/verify-certificate" element={<VerifyCertificatePage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/companies" element={<CompaniesPage />} />
          <Route path="/ethical-hacking-course-jaipur" element={<EthicalHackingJaipur />} />
          <Route path="/cyber-security-training-jaipur" element={<CyberSecurityTrainingJaipur />} />
          <Route path="/soc-analyst-course-jaipur" element={<SOCAnalystCourseJaipur />} />
          <Route path="/vapt-training-jaipur" element={<VAPTTrainingJaipur />} />
          <Route path="/bug-bounty-course-jaipur" element={<BugBountyCourseJaipur />} />
          <Route path="/digital-forensics-jaipur" element={<DigitalForensicsJaipur />} />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-conditions" element={<TermsConditionsPage />} />
        </Routes>
        <Footer />
        <SocialProof />
      </BrowserRouter>
    </div>
  );
}

export default App;
